import { inject, Injectable } from "@angular/core";
import { VolunteersService } from "../../services/volunteer/volunteers.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { volunteersActions } from "./volunteer.actions";

@Injectable()
export class VolunteerEffects {

    private readonly action$ = inject(Actions);
    private readonly volunteerService = inject(VolunteersService);


    loadFromApiVolunteer$ = createEffect(() => {
        return this.action$.pipe(
            ofType(volunteersActions["[Volunteer-API]LoadVolunteer"]),
            switchMap((payload) => this.volunteerService.getVolunteer(payload.paylod).pipe(
                map(volunteersResponse => volunteersActions["[Volunteer-API]LoadSuccess"](volunteersResponse)),
                catchError((volunteersResponse) => of(volunteersActions["[Volunteer-API]LoadFailed"](volunteersResponse)))
            ))
        )
    })
}